export default __webpack_public_path__ + "static/media/radiobuttonchecked.fc011cad.svg";